import { ROUTE_NAMES } from 'src/router/routeNames.const'
import { FEATURE_IDS } from 'src/tpbp-core/feature-flag/featureFlags.const'
import { hasFeature } from 'src/tpbp-core/feature-flag/featureFlags.utils'

export const CALL_TO_ACTION_LINKS = {
  fastCircuit: 'fast_circuit',
  inheritance: 'inheritance',
  patrimonialGrowth: 'patrimonial_growth',
}

function getLinkRouteForInheritance() {
  const newTransmissionCircuit = hasFeature(FEATURE_IDS.transmissionCircuit)
  return newTransmissionCircuit
    ? ROUTE_NAMES.transmissionCircuit.transmissionPagesContainer
    : ''
}

export function getCallToActionLinkRoute() {
  return {
    [CALL_TO_ACTION_LINKS.inheritance]: getLinkRouteForInheritance(),
    [CALL_TO_ACTION_LINKS.patrimonialGrowth]: ROUTE_NAMES.dmp,
  } as const
}
